/**
 * Krok UXP5 bod 2 — CASTKA MEZI API A POLEM, KTERE PREPISUJE CLOVEK.
 *
 * Nataceni 11. 10. 2026: cena v inzeratu se ulozila jako
 * „690000069000006900000", pole se zobrazilo prazdne a opakovane psani
 * castku prodluzovalo. Pricina byla na obou stranach prevodu:
 *  - API posila `numeric(18,4)` („6900000.0000"); vlozit to do pole znamena,
 *    ze z desetinnych mist budou pri ulozeni dalsi cislice;
 *  - cteni pole skrtalo tecku VZDY, takze „.0000" pribylo k cisteke castce.
 *
 * Proto JEDEN modul pro oba smery. Zije zvlast od `properties.ts`, protoze ho
 * cte editor ceny v inzeratu, zaklad provize na fakture i pole „Cenová
 * představa" v zalozeni zakazky — a `properties.ts` si testy techto obrazovek
 * nahrazuji atrapou (`vi.mock`), takze tam by prevod castky nebyl merit.
 */

export interface MoneyText {
  readonly amount: string;
  readonly currency: string;
}

/**
 * Castka do editovatelneho pole: cele koruny, nebo s desetinami, kdyz nejsou
 * nulove. ZADNE formatovani (mezery, „Kč") — vysledek jde zpatky do API.
 */
export function moneyInputAmount(price: MoneyText | null): string {
  if (price === null) return '';
  return price.amount.includes('.')
    ? price.amount.replace(/0+$/, '').replace(/\.$/, '')
    : price.amount;
}

/**
 * Castka z ruky cloveka: „6 900 000", „6900000 Kč", „6.900.000", „6900000,50".
 * Tecka je DESETINNA, dokud jich neni vic — teprve pak jsou to oddelovace
 * tisicu. `null` = nesrozumitelne (volajici ukaze chybu, nic se nedomysli).
 */
export function parseMoneyInput(raw: string, currency = 'CZK'): MoneyText | null {
  let digits = raw.trim().replace(/\s/g, '').replace(/kč$/i, '').replace(/czk$/i, '').replace(',', '.');
  if ((digits.match(/\./g) ?? []).length > 1) digits = digits.replace(/\./g, '');
  if (!/^\d+(\.\d{1,2})?$/.test(digits) || Number(digits) <= 0) return null;
  return { amount: digits, currency };
}
